/** Autor-Darstellung an Anmerkungen: Farbe, Kürzel, Mensch oder Agent. */

import { colorFromId } from '../components/colorFromId'

/** Zwei Buchstaben für den Avatar: Anfangsbuchstaben der ersten zwei Wörter. */
export function initials(name?: string | null, id?: string | null): string {
  const base = (name || (id ? id.replace(/^(agent|user):/, '') : '') || '?').trim()
  const words = base.split(/[\s_\-·.]+/).filter(Boolean)
  const letters = words.length >= 2 ? words[0][0] + words[1][0] : base.slice(0, 2)
  return letters.toUpperCase()
}

export function isAgentId(id?: string | null): boolean {
  return !!id && id.startsWith('agent:')
}

/** Farbe des Autors: Registry für Agenten, sonst Palette aus dem Namen. */
export function colorOf(authorId?: string | null, authorName?: string | null): string {
  return colorFromId(authorId || authorName || '?', authorName)
}
